export default __webpack_public_path__ + "static/media/basemap2-2.83302340.jpg";